import mainLogo from "../../../img/Logo.png";

const MainLogo = () => {
	return <img src={mainLogo} className="h-9 w-auto" />;
};

export default MainLogo;
